

































































import Vue from 'vue';
import { mapActions } from 'vuex';

import QuoteServiceTemplateFormDialog from '@/components/quotes/templates/services/QuoteServiceTemplateFormDialog.vue';
import QuoteServiceTemplateList from '@/components/quotes/templates/services/QuoteServiceTemplateList.vue';
import ALPage from '@/components/core/Page/ALPage.vue';

import {
  IQuoteServiceTemplate,
  IQuoteServiceTemplateData,
  QuoteServiceTemplate
} from '@/models';
import { ErrorManager } from '@/models/error';

export default Vue.extend({
  components: {
    QuoteServiceTemplateList,
    QuoteServiceTemplateFormDialog,
    ALPage
  },
  data: () => ({
    search: '',

    errorMessage: '',
    detailErrorMessage: ''
  }),

  methods: {
    ...mapActions({
      deleteQuoteServiceTemplate: 'quoteTemplate/deleteQuoteServiceTemplate'
    }),

    openService(item?: IQuoteServiceTemplateData, createForm = true) {
      const dialog = (this as any).$refs.quoteServiceFormDialog;
      dialog.open(new QuoteServiceTemplate(item), createForm);
    },

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async deleteQuoteServiceItem(item: IQuoteServiceTemplate) {
      const confirm = (this as any).$refs.confirm;
      const title = item.title;

      if (
        await confirm.open(
          'Delete Quote Service',
          {},
          `<span style="line-height: 19px;">Are you sure you want to delete <div><strong class="text--primary" style="word-break: normal">${title}</strong>?</div> <br /> This action cannot be undone.</span>`
        )
      ) {
        this.clearAllErrors();
        await this.deleteQuoteServiceTemplate(item.id).catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        });
      }
    }
  }
});
